import { MapLocation } from 'app/agriculture/queries/types/MapLocation';
import { Position } from 'app/agriculture/queries/types/geometry/Position';

export function convertMapLocationToPosition(location?: MapLocation | null) {
    if (location == null) return null;

    const { latitude, longitude } = location;

    const position: Position = [longitude, latitude];

    return position;
}
